import * as React from 'react';
import styled from 'styled-components';

import { CardLine } from '../ui/divider/CardLine';
import { CardWrapper } from './CardWrapper';
import { CardImage } from './CardImage';
import { CardSticker } from './CardSticker';
import { Button } from '../ui/button/Button';
import { ConfirmBox } from '../ui/popup/ConfirmBox';
import { useMutation } from '@apollo/client';
import { getAdminClient } from './admin/AdminApolloClient';
import { DEL_PROPERTY_OF_THE_WEEK_MUTATION } from '../../../client/__graphql__/mutations/delPropertyOfTheWeek';
import { Estate } from '../../__types__/generated/cluster';
import { Area } from './Area';
import Price from './Price';

export const CardStyle = styled.div`
  color: ${({ theme }) => theme.colors.black};
  position: relative;
  bottom: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  width: 90%;
  margin: 0 auto;
  height: 199px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  box-shadow: 0 0 20px rgb(0, 0, 0, 0.4);
  h1 {
    font-size: 30px;
  }
  p {
    margin-bottom: 0;
  }
`;
const client = getAdminClient();

export const PropertyCard: React.FC<{
  estate: Estate;
  urltag?: string;
  showCardSticker?: boolean;
  showDeleteBtn?: boolean;
  onRefresh?: any;
}> = ({
  urltag,
  estate,
  children,
  showCardSticker,
  showDeleteBtn,
  onRefresh,
}) => {
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [del, { data, loading, error }] = useMutation(DEL_PROPERTY_OF_THE_WEEK_MUTATION, { client, });

    const clickDelete = (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      setShowConfirm(true);
    };

    const close = () => {
      setShowConfirm(false);
    };

    const handleDeletAsync = async (e: any) => {
      e.preventDefault();

      try {
        var res = await del({
          variables: {
            input: {
              oppdragsnummer: estate.assignmentNumber,
              urltag: urltag,
            },
          },
        });

        var success = false;

        if (res && res.data && res.data.deletePropertyHighLighted)
          success = res.data.deletePropertyHighLighted;

        if (success == true && onRefresh) {
          onRefresh();
        }
      }
      catch { }
    };

    return (
      <CardWrapper as="a" target="_blank" href={`https://privatmegleren.no/${estate.assignmentNumber}`}>
        <CardImage image={estate.images?.main?.url ?? ''} description={'eiendomsbilde'} />
        {showCardSticker ? <CardSticker sold={estate.sold} /> : null}

        <CardStyle>
          <h1>{estate.postalPlace}</h1>
          <CardLine />
          <span>{`${estate.type} - `}<Area size={estate.size} /></span>
          <Price prices={estate.prices} />
          {showDeleteBtn ? (
            <Button type="primary" colorTheme="gold" onClick={clickDelete}>
              Slett
            </Button>
          ) : null}
        </CardStyle>
        {showConfirm && <ConfirmBox close={close} handleDelete={handleDeletAsync} />}
      </CardWrapper>
    );
  };
